import React from "react";
import { Card, Tabs } from "antd";
import CookieUtil from "./../../utils/CookieUtil";
import { Redirect } from "react-router-dom";

import ModalUltil from "../../utils/ModalUtil";
import ClienteService from "../../services/ClienteService";
import StorageService from "../../services/StorageService";
import CommonUtil from "../../utils/CommonUtil";
import NotificationUtil from '../../utils/NotificationUtil';
import UmkLicencaEditar from '../../components/cliente/Licenca/UmkLicencaEditar';
import UmkLicencaDesativar from '../../components/cliente/Licenca/UmkLicencaDesativar';
import UmkLicencaRenovar from '../../components/cliente/Licenca/UmkLicencaRenovar';

class LicencaPage extends React.Component<any, any> {
    private CookieUtil: CookieUtil;
    private ModalUltil: ModalUltil;
    private ClienteService: ClienteService;
    private storage: StorageService;
    private CommonUtil: CommonUtil;
    private NotificationUtil: NotificationUtil;

    state = {
        redirect: false,
        redirectPage: '',
        action: ''
    };

    constructor(props: any) {
        super(props);

        this.CookieUtil = new CookieUtil();
        this.ModalUltil = new ModalUltil(props);
        this.NotificationUtil = new NotificationUtil();
        this.ClienteService = new ClienteService();
        this.storage = new StorageService();
        this.CommonUtil = new CommonUtil();

        this.checkLogin = this.checkLogin.bind(this);
        this.checkPage = this.checkPage.bind(this);
        this.validateAction = this.validateAction.bind(this);
    }

    componentDidMount() {
        document.title = "Unimake Software - Licença";

        this.checkLogin();
        this.checkPage();
    }

    async checkLogin() {
        let token = await this.CookieUtil.Get("TokenUsuario");

        if (!token || token === "undefined") {
            localStorage.setItem("redirect", "true");
            localStorage.setItem("redirectPath", window.location.pathname);

            this.setState({
                redirect: true,
                redirectPage: `${process.env.PUBLIC_URL}/cliente/login`,
            });
        }
    }

    checkPage() {
        try {
            let url = window.location.href;
            let parts = url.split('/');

            let expected = parts[5];

            var action = expected.substring(
                0,
                expected.lastIndexOf("?")
            );

            this.validateAction(action);
        } catch (error) {
            this.NotificationUtil.Error('Ação para está pagina não identificada');
            this.setState({
                redirect: true,
                redirectPage: `${process.env.PUBLIC_URL}/cliente/dashboard`,
            });
        }
    }

    validateAction(action: string) {
        try {
            switch (action) {
                case 'editar':
                case 'desativar':
                case 'renovar':
                    this.setState({
                        action: action,
                    })
                    break;

                default:
                    throw Error("Ação não identificada");
                    break;
            }
        } catch (error) {
            this.NotificationUtil.Error('Ação para está pagina não identificada');
            this.setState({
                redirect: true,
                redirectPage: `${process.env.PUBLIC_URL}/cliente/login`,
            });
        }
    }

    renderAction() {
        let action: string = this.state.action;

        switch (action) {
            case 'editar':
                return (
                    <UmkLicencaEditar />
                );

            case 'desativar':
                return <UmkLicencaDesativar />;

            case 'renovar':
                return <UmkLicencaRenovar />;

            default:
                return null;
        }
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirectPage} />;
        }

        return (
            <section className="unimake-container">
                <Card style={{ height: "auto" }} className="content-area">
                    {this.renderAction()}
                </Card>
            </section>
        );
    }
}
export default LicencaPage;
